var _path, _path2, _path3, _g, _path4, _path5, _path6, _g2, _path7, _g3, _path8, _path9, _path10, _g4, _path11, _path12, _path13, _g5, _path14, _g6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrainacsLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 65,
    viewBox: "0 0 72 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_584_72",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 40,
    width: 25,
    height: 26
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 40.7007H24.5725V65.0003H0V40.7007Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_584_72)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_584_72",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 38,
    width: 31,
    height: 30
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9369 67.5425L-2.64161 61.5115L3.45708 38.1948L27.0356 44.2258L20.9369 67.5425Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_584_72)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_584_72",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 40,
    width: 25,
    height: 25
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14804 64.5275C2.63684 62.8621 -1.27638 56.2922 0.407741 49.854C2.09186 43.4151 8.73554 39.5454 15.2467 41.2108C21.7579 42.8762 25.6704 49.4461 23.9862 55.885C22.3021 62.3231 15.6584 66.1929 9.14804 64.5275L10.3673 59.8638C14.2742 60.8632 18.2604 58.542 19.271 54.6785C20.2809 50.815 17.9336 46.8739 14.0267 45.8744C10.1206 44.875 6.13439 47.1971 5.12376 51.0598C4.11313 54.9233 6.46122 58.8652 10.3673 59.8638L9.14804 64.5275Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_584_72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9369 67.5425L-2.64162 61.5115L3.45708 38.1948L27.0356 44.2258L20.9369 67.5425Z",
    fill: "#FFA500"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_584_72",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 40,
    width: 24,
    height: 24
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 40.7007H23.354V63.7954H0V40.7007Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_584_72)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_584_72",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 38,
    width: 28,
    height: 29
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5214 66.6331L-2.66224 61.2148L3.38886 38.0801L24.5725 43.4984L18.5214 66.6331Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_584_72)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_584_72",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 40,
    width: 24,
    height: 24
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29701 63.4026C1.7682 60.9221 -0.679847 55.8804 0.195135 50.8339C1.07012 45.7874 5.07616 41.84 10.1825 40.9928C15.2888 40.1456 20.3784 42.5837 22.8709 47.0716C23.5182 48.2381 23.0875 49.7019 21.9087 50.342C20.7291 50.9822 19.2488 50.5562 18.6015 49.3905C17.1062 46.6982 14.0521 45.2344 10.9884 45.7427C7.92481 46.2511 5.52118 48.6201 4.99604 51.6474C4.47089 54.6754 5.94003 57.7003 8.657 59.1892C9.41854 59.6058 9.89689 60.3926 9.91196 61.2532C9.92782 62.113 9.47804 62.9162 8.73236 63.3595C7.98668 63.8035 7.05855 63.82 6.29701 63.4026Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_584_72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9369 67.5425L-2.64161 61.5115L3.45708 38.1948L27.0356 44.2258L20.9369 67.5425Z",
    fill: "#6D6D6D"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_584_72",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 15,
    width: 33,
    height: 33
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2536 15.4116H72V47.7944H39.2536V15.4116Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_584_72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.0071 31.6061C72.0071 31.8713 72.0008 32.1364 71.9873 32.4008C71.9746 32.6659 71.9548 32.9303 71.9286 33.1939C71.9016 33.4575 71.8691 33.7203 71.8302 33.9831C71.7906 34.2451 71.7445 34.5055 71.6922 34.766C71.6398 35.0256 71.5811 35.2845 71.5161 35.5418C71.451 35.7983 71.3796 36.0541 71.3019 36.3074C71.2242 36.5608 71.1401 36.8126 71.0496 37.0621C70.9592 37.3116 70.8632 37.5587 70.7601 37.8042C70.6578 38.0489 70.5491 38.2913 70.4348 38.5306C70.3198 38.7699 70.2 39.0068 70.0731 39.2406C69.947 39.4743 69.8153 39.705 69.6773 39.9324C69.5392 40.1599 69.3957 40.3835 69.2473 40.604C69.0982 40.8244 68.9443 41.0409 68.784 41.2535C68.6246 41.4669 68.4596 41.6755 68.2898 41.8803C68.1201 42.085 67.9448 42.2858 67.7647 42.482C67.5846 42.6789 67.3998 42.8703 67.2102 43.0578C67.0206 43.2452 66.827 43.428 66.6279 43.6061C66.4296 43.7842 66.2265 43.9568 66.0195 44.1254C65.8124 44.2933 65.6014 44.4565 65.3857 44.6141C65.1707 44.7718 64.9517 44.9248 64.7288 45.0723C64.5059 45.219 64.2798 45.361 64.0498 45.4974C63.8197 45.6332 63.5865 45.7642 63.3501 45.8889C63.1137 46.0136 62.8749 46.1329 62.6322 46.2466C62.3902 46.3596 62.1451 46.467 61.8976 46.5682C61.6501 46.6702 61.3994 46.7651 61.1472 46.8546C60.8949 46.944 60.6411 47.0272 60.3841 47.104C60.1278 47.1809 59.8692 47.2515 59.6098 47.3158C59.3496 47.3802 59.0878 47.4382 58.8253 47.49C58.5627 47.5418 58.2985 47.5873 58.0336 47.6257C57.7678 47.6649 57.5021 47.6971 57.2355 47.723C56.969 47.7496 56.7017 47.7685 56.4335 47.7818C56.1662 47.7952 55.8981 47.8014 55.63 47.8014C55.3626 47.8014 55.0945 47.7952 54.8264 47.7818C54.559 47.7685 54.2917 47.7496 54.0252 47.723C53.7586 47.6971 53.4921 47.6649 53.2271 47.6257C52.9622 47.5873 52.698 47.5418 52.4354 47.49C52.1729 47.4382 51.9111 47.3802 51.6509 47.3158C51.3915 47.2515 51.1329 47.1809 50.8767 47.104C50.6196 47.0272 50.3658 46.944 50.1135 46.8546C49.8605 46.7651 49.6106 46.6702 49.3631 46.5682C49.1156 46.467 48.8705 46.3596 48.6285 46.2466C48.3858 46.1329 48.147 46.0136 47.9106 45.8889C47.6742 45.7642 47.441 45.6332 47.2109 45.4974C46.9809 45.361 46.7548 45.219 46.5319 45.0723C46.309 44.9248 46.09 44.7718 45.8751 44.6141C45.6593 44.4565 45.4483 44.2933 45.2412 44.1254C45.0342 43.9568 44.8311 43.7842 44.632 43.6061C44.4337 43.428 44.2393 43.2452 44.0505 43.0578C43.8609 42.8703 43.6761 42.6789 43.496 42.482C43.316 42.2858 43.1406 42.085 42.9709 41.8803C42.8011 41.6755 42.6361 41.4669 42.4767 41.2535C42.3164 41.0409 42.1625 40.8244 42.0134 40.604C41.8643 40.3835 41.7215 40.1599 41.5834 39.9324C41.4454 39.705 41.3137 39.4743 41.1876 39.2406C41.0607 39.0068 40.9409 38.7699 40.8259 38.5306C40.7116 38.2913 40.603 38.0489 40.4998 37.8042C40.3975 37.5587 40.3015 37.3116 40.2111 37.0621C40.1206 36.8126 40.0366 36.5608 39.9588 36.3074C39.8811 36.0541 39.8097 35.7983 39.7446 35.5418C39.6796 35.2845 39.6209 35.0256 39.5685 34.766C39.5162 34.5055 39.4702 34.2451 39.4305 33.9831C39.3916 33.7203 39.3583 33.4575 39.3321 33.1939C39.3059 32.9303 39.2861 32.6659 39.2734 32.4008C39.2599 32.1364 39.2536 31.8713 39.2536 31.6061C39.2536 31.341 39.2599 31.0766 39.2734 30.8115C39.2861 30.5471 39.3059 30.2827 39.3321 30.0192C39.3583 29.7556 39.3916 29.492 39.4305 29.23C39.4702 28.968 39.5162 28.7067 39.5685 28.4471C39.6209 28.1866 39.6796 27.9286 39.7446 27.6713C39.8097 27.4139 39.8811 27.159 39.9588 26.9056C40.0366 26.6514 40.1206 26.4004 40.2111 26.1502C40.3015 25.9007 40.3975 25.6536 40.4998 25.4089C40.603 25.1641 40.7116 24.9217 40.8259 24.6824C40.9409 24.4424 41.0607 24.2063 41.1876 23.9725C41.3137 23.7387 41.4454 23.5081 41.5834 23.2806C41.7215 23.0531 41.8643 22.8295 42.0134 22.6091C42.1625 22.3887 42.3164 22.1721 42.4767 21.9588C42.6361 21.7462 42.8011 21.5375 42.9709 21.3328C43.1406 21.1272 43.316 20.9272 43.496 20.7303C43.6761 20.5342 43.8609 20.342 44.0505 20.1545C44.2393 19.9678 44.4337 19.785 44.632 19.6069C44.8311 19.4289 45.0342 19.2555 45.2412 19.0876C45.4483 18.9198 45.6593 18.7566 45.8751 18.5989C46.09 18.4404 46.309 18.2883 46.5319 18.1408C46.7548 17.9933 46.9809 17.8521 47.2109 17.7156C47.441 17.5791 47.6742 17.4489 47.9106 17.3241C48.147 17.1986 48.3858 17.0794 48.6285 16.9664C48.8705 16.8527 49.1156 16.746 49.3631 16.644C49.6106 16.5428 49.8605 16.4471 50.1135 16.3585C50.3658 16.269 50.6196 16.1859 50.8767 16.109C51.1329 16.0321 51.3915 15.9615 51.6509 15.8972C51.9111 15.8321 52.1729 15.774 52.4354 15.7231C52.698 15.6713 52.9622 15.6258 53.2271 15.5866C53.4921 15.5481 53.7586 15.5152 54.0252 15.4893C54.2917 15.4634 54.559 15.4438 54.8264 15.4312C55.0945 15.4179 55.3626 15.4116 55.63 15.4116C55.8981 15.4116 56.1662 15.4179 56.4335 15.4312C56.7017 15.4438 56.969 15.4634 57.2355 15.4893C57.5021 15.5152 57.7678 15.5481 58.0336 15.5866C58.2985 15.6258 58.5627 15.6713 58.8253 15.7231C59.0878 15.774 59.3496 15.8321 59.6098 15.8972C59.8692 15.9615 60.1278 16.0321 60.3841 16.109C60.6411 16.1859 60.8949 16.269 61.1472 16.3585C61.3994 16.4471 61.6501 16.5428 61.8976 16.644C62.1451 16.746 62.3902 16.8527 62.6322 16.9664C62.8749 17.0794 63.1137 17.1986 63.3501 17.3241C63.5865 17.4489 63.8197 17.5791 64.0498 17.7156C64.2798 17.8521 64.5059 17.9933 64.7288 18.1408C64.9517 18.2883 65.1707 18.4404 65.3857 18.5989C65.6014 18.7566 65.8124 18.9198 66.0195 19.0876C66.2265 19.2555 66.4296 19.4289 66.6279 19.6069C66.827 19.785 67.0206 19.9678 67.2102 20.1545C67.3998 20.342 67.5846 20.5342 67.7647 20.7303C67.9448 20.9272 68.1201 21.1272 68.2898 21.3328C68.4596 21.5375 68.6246 21.7462 68.784 21.9588C68.9443 22.1721 69.0982 22.3887 69.2473 22.6091C69.3957 22.8295 69.5392 23.0531 69.6773 23.2806C69.8153 23.5081 69.947 23.7387 70.0731 23.9725C70.2 24.2063 70.3198 24.4424 70.4348 24.6824C70.5491 24.9217 70.6578 25.1641 70.7601 25.4089C70.8632 25.6536 70.9592 25.9007 71.0496 26.1502C71.1401 26.4004 71.2242 26.6514 71.3019 26.9056C71.3796 27.159 71.451 27.4139 71.5161 27.6713C71.5811 27.9286 71.6398 28.1866 71.6922 28.4471C71.7445 28.7067 71.7906 28.968 71.8302 29.23C71.8691 29.492 71.9016 29.7556 71.9286 30.0192C71.9548 30.2827 71.9746 30.5471 71.9873 30.8115C72.0008 31.0766 72.0071 31.341 72.0071 31.6061Z",
    fill: "#6D6D6D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_584_72",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 27,
    width: 50,
    height: 26
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2309 27.647H64.782V52.1474H15.2309V27.647Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_584_72)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_584_72",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 25,
    width: 52,
    height: 29
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.275 48.9959L63.3842 25.7593L65.7593 30.67L16.6508 53.9059L14.275 48.9959Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_584_72)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_584_72",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 27,
    width: 50,
    height: 25
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.094 31.5738C57.8718 28.3669 63.8983 26.8662 64.5543 28.2217C65.2104 29.5781 60.2476 33.2768 53.4691 36.4837L28.9236 48.0978C22.1458 51.3054 16.1185 52.8061 15.4625 51.4498C14.8073 50.0942 19.77 46.3955 26.5477 43.1878L51.094 31.5738Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_584_72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.275 48.9953L63.3644 25.7681L65.7403 30.678L16.6508 53.9053L14.275 48.9953Z",
    fill: "#6D6D6D"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_584_72",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 11,
    width: 33,
    height: 21
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3694 11.1807H56.2527V31.6646H24.3694V11.1807Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_584_72)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask11_584_72",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 9,
    width: 35,
    height: 25
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9663 9.28418L57.5886 28.8958L54.6416 33.5422L23.0193 13.9306L25.9663 9.28418Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_584_72)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask12_584_72",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 11,
    width: 33,
    height: 21
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9679 21.6892C52.3824 25.6664 56.9223 29.9316 56.1084 31.2142C55.2945 32.4976 49.4353 30.3128 43.0217 26.3348L34.6328 21.1322C28.2192 17.155 23.6793 12.8899 24.4932 11.6065C25.3063 10.3239 31.1654 12.5086 37.5798 16.4866L45.9679 21.6892Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_584_72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.9663 9.28418L57.5886 28.8958L54.6416 33.5422L23.0193 13.9306L25.9663 9.28418Z",
    fill: "#6D6D6D"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_584_72",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 24,
    height: 24
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1982 0H35.9449V23.4963H12.1982V0Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_584_72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.9417 11.7395C35.9417 12.1239 35.9227 12.5075 35.8846 12.8903C35.8465 13.2732 35.7902 13.6528 35.714 14.0302C35.6379 14.4067 35.5435 14.7793 35.4308 15.1472C35.3182 15.5152 35.1873 15.8768 35.0382 16.2322C34.8898 16.5875 34.7232 16.935 34.54 17.2739C34.3567 17.6128 34.1576 17.9423 33.9411 18.2616C33.7253 18.5816 33.4937 18.8899 33.247 19.1872C33.001 19.4846 32.74 19.7693 32.4648 20.0407C32.1903 20.313 31.9024 20.571 31.6017 20.815C31.301 21.059 30.9893 21.2873 30.6656 21.5006C30.3428 21.7148 30.0096 21.9117 29.6669 22.0929C29.3234 22.2749 28.9728 22.4389 28.6134 22.5856C28.2541 22.733 27.8884 22.8625 27.5163 22.9739C27.1443 23.0853 26.7675 23.1786 26.3867 23.2539C26.0051 23.3292 25.6212 23.3849 25.2341 23.4234C24.847 23.461 24.4591 23.4798 24.0703 23.4798C23.6816 23.4798 23.2937 23.461 22.9066 23.4234C22.5195 23.3849 22.1356 23.3292 21.754 23.2539C21.3732 23.1786 20.9964 23.0853 20.6244 22.9739C20.2523 22.8625 19.8866 22.733 19.5273 22.5856C19.1679 22.4389 18.8173 22.2749 18.4738 22.0929C18.1311 21.9117 17.7979 21.7148 17.4751 21.5006C17.1514 21.2873 16.8396 21.059 16.539 20.815C16.2383 20.571 15.9504 20.313 15.6759 20.0407C15.4006 19.7693 15.1397 19.4846 14.893 19.1872C14.647 18.8899 14.4154 18.5816 14.1996 18.2616C13.9831 17.9423 13.784 17.6128 13.6007 17.2739C13.4175 16.935 13.2509 16.5875 13.1025 16.2322C12.9534 15.8768 12.8225 15.5152 12.7099 15.1472C12.5972 14.7793 12.5028 14.4067 12.4267 14.0302C12.3505 13.6528 12.2942 13.2732 12.2561 12.8903C12.2172 12.5075 12.1982 12.1239 12.1982 11.7395C12.1982 11.3551 12.2172 10.9715 12.2561 10.5887C12.2942 10.2059 12.3505 9.82622 12.4267 9.44889C12.5028 9.07235 12.5972 8.69973 12.7099 8.33181C12.8225 7.9639 12.9534 7.60226 13.1025 7.24689C13.2509 6.89153 13.4175 6.5448 13.6007 6.20512C13.784 5.86623 13.9831 5.53676 14.1996 5.21748C14.4154 4.89742 14.647 4.58912 14.893 4.29181C15.1397 3.9945 15.4006 3.70974 15.6759 3.43831C15.9504 3.1661 16.2383 2.9088 16.539 2.66483C16.8396 2.42086 17.1514 2.1918 17.4751 1.97842C17.7979 1.76426 18.1311 1.56736 18.4738 1.38615C18.8173 1.20494 19.1679 1.0402 19.5273 0.893506C19.8866 0.746027 20.2523 0.61659 20.6244 0.505196C20.9964 0.393802 21.3732 0.30045 21.754 0.225142C22.1356 0.150617 22.5195 0.0941359 22.9066 0.0564815C23.2937 0.0188272 23.6816 0 24.0703 0C24.4591 0 24.847 0.0188272 25.2341 0.0564815C25.6212 0.0941359 26.0051 0.150617 26.3867 0.225142C26.7675 0.30045 27.1443 0.393802 27.5163 0.505196C27.8884 0.61659 28.2541 0.746027 28.6134 0.893506C28.9728 1.0402 29.3234 1.20494 29.6669 1.38615C30.0096 1.56736 30.3428 1.76426 30.6656 1.97842C30.9893 2.1918 31.301 2.42086 31.6017 2.66483C31.9024 2.9088 32.1903 3.1661 32.4648 3.43831C32.74 3.70974 33.001 3.9945 33.247 4.29181C33.4937 4.58912 33.7253 4.89742 33.9411 5.21748C34.1576 5.53676 34.3567 5.86623 34.54 6.20512C34.7232 6.5448 34.8898 6.89153 35.0382 7.24689C35.1873 7.60226 35.3182 7.9639 35.4308 8.33181C35.5435 8.69973 35.6379 9.07235 35.714 9.44889C35.7902 9.82622 35.8465 10.2059 35.8846 10.5887C35.9227 10.9715 35.9417 11.3551 35.9417 11.7395Z",
    fill: "#FFA500"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrainacsLogo);
export default __webpack_public_path__ + "static/media/brainacs-Logo.20bd2c369a233f4d657b277a3ea04085.svg";
export { ForwardRef as ReactComponent };